import API from "./api";
// OpenInNewModalSVG removed - unused
import { ShowProposalSubmitting, ShowProposalSuccess } from "./snackbar";
import OpenDialog from "./dialog";
import OpenErrorDialog from "./dialog_error";

const Positives = () => window.map_data["Positive Properties"].map(pos => pos.Term);

export default class extends HTMLElement {
    #button = null;

    connectedCallback () {
        this.#button = this.querySelector("button");

        this.#button.addEventListener("click", async (e) => {
            e.preventDefault();
            this.openDialog();
        });
    }

    openDialog () {
        const el = document.createElement("div");
        el.innerHTML = `
            <form id="propose-resource-form" method="dialog">
                <input type="text" required placeholder="Term" name="term" />
                <textarea required placeholder="Description" name="description"></textarea>
                <div>
					<label for="harms">Positive relationships</label>
					${this.positivesSelectControlMarkup()}
				</div>
                <textarea required placeholder="General reasoning. How is this harm novel?" name="reasoning"></textarea>
                <button type="submit" value="confirm">Propose new harm</button>
            </form>
        `;

        const dialog = OpenDialog("Propose a new harm", el.innerHTML);

        const handler = async (e) => {
            dialog.removeEventListener("close", handler);
            if (e.target.returnValue !== "confirm") {
                return;
            }
            e.target.returnValue = "";
            const form = e.target.querySelector("form#propose-resource-form");

            const formData = new FormData(form);

            ShowProposalSubmitting();

            const response = await API.proposeNewHarm(
                formData.get("term"),
                formData.get("description"),
                formData.getAll("positives"),
                formData.get("reasoning"),
            );

            if (response.ok) {
                ShowProposalSuccess();
            } else {
                const errorData = await response.json();
                OpenErrorDialog(errorData);
                return;
            }

            return false;
        };

        dialog.addEventListener("close", handler);
    }

    positivesSelectControlMarkup () {
        const selectList = document.createElement("select");
        selectList.role = "new-positive-relation";
        selectList.name = "positives";
        selectList.id = "positives";
        selectList.multiple = true;

        Positives().forEach(harm => {
            const option = document.createElement("option");
            option.value = harm;
            option.text = harm;
            selectList.appendChild(option);
        });

        return selectList.outerHTML;
    }
}
